import { HttpClient, HttpResponse } from '@angular/common/http';
import { InjectionToken, isDevMode, NgModuleFactory } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, retryWhen } from 'rxjs/operators';
import { PageInstance } from './models/page-instance.model';
import { genericRetryStrategy } from '../misselaineous/generic-retry-strategy';

export declare type LoadModuleCallback = () => Promise<NgModuleFactory<any>>;
export interface PageTypeModuleReference { [key: string]: LoadModuleCallback; }
export const PAGE_TYPE_MODULE_REFERENCE = new InjectionToken<PageTypeModuleReference>('PAGE_TYPE_MODULE_REFERENCE');
export const CONTENT_CACHE = new InjectionToken<{ [key: string]: any; }>('CONTENT_CACHE');
export const TITLE_POSTFIX = new InjectionToken<string>('TITLE_POSTFIX');
export const GET_CONTENT_FN = new InjectionToken<(url: string) => Observable<any>>('GET_CONTENT_FN');
export const ERROR_PATH = new InjectionToken<string>('ERROR_PATH');
export const PAGE_FNS = new InjectionToken<Array<(pageInstace: PageInstance) => void>>('PAGE_FNS');


export function getContentCache(document: Document): { [key: string]: any; } {
    const cache: { [key: string]: any; } = {};
    try {
        Object.assign(cache, (window as any).__CONTENT_CACHE as { [key: string]: any; });
        if (!isDevMode()) {
            (window as any).__CONTENT_CACHE = null;
            document.getElementById('CONTENT_CACHE_SCRIPT').remove();
        }
    } catch {}
    return cache;
}


export function loadContent(url: string, baseUrl: string, httpClient: HttpClient): Observable<HttpResponse<any>> {
    return httpClient.get(`${baseUrl}${url}`, {
        observe: 'response',
        params: { type: 'json' }
    }).pipe(
        retryWhen(genericRetryStrategy({
            scalingDuration: 2000,
            excludedStatusCodes: [400, 401, 404, 500]
        })),
        catchError(error => {
            if (error.error instanceof Error) {
                // A client-side or network error occurred. Handle it accordingly.
                console.error('An error occurred:', error.error.message);
            } else if (error.status === 404) {
                console.log(error);
                return of({ body: error.error } as HttpResponse<any>);
            } else {
                // The backend returned an unsuccessful response code.
                // The response body may contain clues as to what went wrong,
                console.error(`Backend returned code ${error.status}, body:`, error.error);
            }

            // ...optionally return a default fallback value so app can continue (pick one)
            // which could be a default value
            // return Observable.of<any>({my: "default value..."});
            // or simply an empty observable
            return of({ body: { ...error.error, status: error.status, error: 'unable to load requested page: ' + url } } as HttpResponse<any>);
        })
    );
}


